<div class="cc-my-account">
  <h3>{{'_General_My_Account_Text_' | translate }}</h3>

  <div class="cc-my-account-content">
    <ngb-accordion [closeOthers]="true" #acc="ngbAccordion" class="cc-accordion" activeIds="ngb-panel-0">
      <!-- Basic Information Tab -->
      <ngb-panel id="ngb-panel-0">
        <ng-template ngbPanelTitle>
          <!-- <img src="../../../../../assets/images/icon/reports.svg"> -->
          <span>{{'_General_Basic_Settings_Text_' | translate }}</span>
          <span class="caret"></span>
        </ng-template>
        <ng-template ngbPanelContent>
          <form [formGroup]="myProfileSettingsForm" (ngSubmit)="saveMyProfile(myProfileSettingsForm.value)">
            <div class="row">
              <!-- Username -->
              <div class="col-md-4">
                <label for="username">{{'_General_Username_Text_' | translate }}</label>
                <input id="username" class="form-control" formControlName="username" type="text" [disabled]="true">
              </div>

              <!-- First Name -->
              <div class="col-md-4">
                <label for="firstname" class="required">
                  {{'_General_User_First_Name_Text_' | translate }}
                  <span tabindex="-1" class="required-field">*</span>
                </label>
                <input id="firstname" class="form-control" formControlName="firstName" type="text" maxlength="50"
                  app-filter pattern="^((?=[^<>&])[A-Za-z0-9`\s\|!@?#\\$\/%\[\]^_*\(\)~=\{\}:;+'&quot;.\-;,])*$">
                <div *ngIf="this.f.firstName.invalid && (this.f.firstName.dirty || this.f.firstName.touched)"
                     class="cc-validation">
                  <div *ngIf="this.f.firstName.errors?.required">
                    {{'_General_User_First_Name_Required_Text_' | translate }}
                  </div>
                </div>
              </div>

              <!-- Last Name -->
              <div class="col-md-4">
                <label for="lastname" class="required">
                  {{'_General_User_Last_Name_Text_' | translate }}
                  <span tabindex="-1" class="required-field">*</span>
                </label>
                <input id="lastname" class="form-control" formControlName="lastName" type="text" maxlength="50"
                  app-filter pattern="^((?=[^<>&])[A-Za-z0-9`\s\|!@?#\\$\/%\[\]^_*\(\)~=\{\}:;+'&quot;.\-;,])*$">
                <div *ngIf="this.f.lastName.invalid && (this.f.lastName.dirty || this.f.lastName.touched)"
                     class="cc-validation">
                  <div *ngIf="this.f.lastName.errors?.required">
                    {{'_General_User_Last_Name_Required_Text_' | translate }}
                  </div>
                </div>
              </div>

              <!-- User Group -->
              <div class="col-md-4">
                <label for="permissionGroup">{{'_General_Permission_Group_Text_' | translate }}</label>
                <input id="permissionGroup" class="form-control" formControlName="permissionGroup"  type="text" [disabled]="true">
              </div>

              <!--Notification Group(s)-->
              <div class="col-md-4">
                <label for="notificationgroups">{{'_General_Notification_Groups_Text_' | translate }}</label>
                <div class="d-flex justify-content-start align-items-center">
                  <button type="button"
                    *ngIf="myProfile.notificationGroups != null && myProfile.notificationGroups.length>1"
                    (click)="openGroupNotificationPopUp(myProfile.notificationGroups)" class="cc-icon-btn"><span
                      class="fas fa-plus"></span></button>
                  <input id="notificationgroups" class="form-control" formControlName="notificationGroups" [disabled]="true"
                    type="text">
                </div>
              </div>
              <!-- Supervisor -->
              <div class="col-md-4" *ngIf="isLTLicenseEnabled$ | async">
                <label for="supervisor">{{'_General_My_Supervisor_Text_' | translate }}</label>
                <input id="supervisor" class="form-control" formControlName="supervisor" [disabled]="true" type="text">
              </div>

              <!-- Preferred Time -->
              <div class="col-md-4" *ngIf="isACLicenseEnabled$ | async">
                <label for="preferredtime">{{'_General_Preferred_Time_Zone_Text_' | translate }}</label>
                <select class="cc-select-dropdown form-control" id="preferredtime" formControlName="preferredTimezone">
                  <option value="0">{{'_My_Account_Select_Preferred_Time_Zone__Text_' | translate }}</option>
                  <option *ngFor="let t of timeZoneList" [ngValue]="t.id">{{t.name}}</option>
                </select>
              </div>

              <!-- Primary Notification Email -->
              <div class="col-md-4">
                <label for="primaryemail" class="required">
                  {{'_General_Primary_Notification_Email_Text_' | translate }}
                  <span tabindex="-1" class="required-field">*</span>
                </label>
                <input id="primaryemail" class="form-control" formControlName="primaryEmail" type="email"
                  maxlength="256">
                <div *ngIf="this.f.primaryEmail.invalid && (this.f.primaryEmail.dirty || this.f.primaryEmail.touched)"
                     class="cc-validation">
                  <div *ngIf="this.f.primaryEmail.errors?.required">
                    {{'_General_Primary_Notification_Email_Required_Text_' | translate }}
                  </div>
                  <div *ngIf="this.f.primaryEmail.errors?.invalidEmail">
                    {{'_General_Invalid_Primary_Notification_Email_Text_' | translate }}
                  </div>
                </div>
              </div>

              <!-- Secondary Notification Email -->
              <div class="col-md-4" *ngIf="isACLicenseEnabled$ | async">
                <label for="secondaryemail">{{'_General_Secondary_Notification_Email_Text_' | translate }}</label>
                <input id="secondaryemail" class="form-control" formControlName="secondaryEmail" type="email"
                  maxlength="256">
                <div
                  *ngIf="this.f.secondaryEmail.invalid && (this.f.secondaryEmail.dirty || this.f.secondaryEmail.touched)"
                  class="cc-validation">
                  <div *ngIf="this.f.secondaryEmail.errors?.invalidEmail">
                    {{'_General_Invalid_Secondary_Notification_Email_Text_' | translate }}
                  </div>
                </div>
              </div>

              <!-- Phone Number -->
              <div class="col-md-4">
                <label for="phoneNumber">{{'_General_Phone_Number_Column_Title_' | translate }}</label>
                <input id="phoneNumber" class="form-control" formControlName="phoneNumber" type="text" maxlength="10"
                  (focusout)="onFocusOutPhoneNumber()" app-filter pattern="(^(\s*|[0-9]*)$)">

                <div *ngIf="invalidPhoneNumber">
                  <div class="cc-validation" *ngIf="invalidPhoneNumber">
                    {{'_General_User_Phone_Invalid_Text_' | translate }}
                  </div>
                </div>
              </div>

              <!-- Preferred Language -->
              <div class="col-md-4">
                <label for="preferredlanguage">{{'_General_Preferred_Language_Text_' | translate }}</label>
                <select class="cc-select-dropdown form-control" id="preferredlanguage"
                        formControlName="preferredLanguage">
                  <option *ngFor="let l of languages" [ngValue]="l.languageId">{{l.languageName | translate}}</option>
                </select>
              </div>
              
              <div class="col-md-4" *ngIf="isLTLicenseEnabled$ | async">

                <label for="defaultMerge">{{'_General_Default_Lobby_Tab_Text_' | translate }}</label>
                <select class="cc-select-dropdown form-control" id="defaultMerge" formControlName="defaultLobbyTab" [(ngModel)]="ngDefaultSelected">
                  <option *ngFor="let option of defaultLobbyTabsMerges" [ngValue]="option.id">{{option.value | translate}}</option>
                </select>
                </div>
                  <div
                    *ngIf="myProfile.allowVirtualAppointments && userService.conferencingProvider!='' && (userService.conferencingProvider === 'Webex' || userService.conferencingProvider === 'GoToMeeting')"
                    class="col-md-4">
                    <label for="conferencingService">{{'_ConferenceService_' | translate }}</label>
                    <div class="conf-provider-container">
                      <p>{{userService.conferencingProvider}}</p>
                      <div class="d-flex">
                        <!-- virtualConferencingAuthStatus :{{virtualConferencingAuthStatus|json}}  : {{userService.conferencingProvider|json}} -->
                        <button class="btn btn-primary" (click)="authorize($event)">{{'_Authorize_' | translate }}</button>
                        <span *ngIf="!virtualConferencingAuthStatus" title="{{'_User_Additional_Account_Not_Authorize_Text_' | translate}}"
                          class="fa fa-exclamation-circle align-self-center unauthorized"></span>
                        <span *ngIf="virtualConferencingAuthStatus" title="{{'_User_Additional_Authorization_Success_Text_' | translate}}"
                          class="fa fa-check-circle align-self-center authorized"></span>
                      </div>
                    </div>
              </div>
            </div>

            <div [style.visibility]="this.profileSaveError ? 'visible' : 'hidden'">
              <div class="cc-validation">
                {{this.profileSaveError}}
              </div>
            </div>
            <!-- Button Panel -->
            <div class="cc-btn-panel">
              <button class="btn btn-secondary" type="button" (click)="this.togglePanel('ngb-panel-0')">{{'_General_Button_Close_Text_' | translate }}</button>
              <button class="btn btn-primary"
                [disabled]="!this.myProfileSettingsForm.dirty || !this.myProfileSettingsForm.valid || invalidPhoneNumber">{{'_General_Button_Save_Text_' | translate }}
              </button>
            </div>
          </form>
        </ng-template>
      </ngb-panel>

      <!-- Change Password Tab -->
      <ngb-panel id="ngb-panel-1" *ngIf="showPasswordReset && tenantConfiguration?.localLoginEnalbed">
        <ng-template ngbPanelTitle>
          <!-- <img src="../../../../../assets/images/icon/reports.svg"> -->
          <span>{{'_My_Account_Change_Password_Tab_Text_' | translate }}</span>
          <span class="caret"></span>
        </ng-template>
        <ng-template ngbPanelContent>
          <form [formGroup]="passwordResetForm" (ngSubmit)="updatePassword(passwordResetForm.value)">
            <div class="row">
              <div class="col-md-4">
                <div class="col">
                  <label for="currentpassword">{{'_My_Account_Current_Password_Label_Text_' | translate }}
                    <span tabindex="-1" class="required-field">*</span>
                  </label>
                  <div class="input-reveal">
                    <input id="currentpassword" class="form-control" autocomplete="off"
                      formControlName="currentpassword" (keypress)="omit_special_char($event)"
                      [type]="showCurrrentPassword ? 'text' : 'password'"
                      (paste)="passwordInputChange('currentpassword')">
                    <span class="cc-icon eye-icon" (click)="showCurrrentPassword = !showCurrrentPassword"><span class="fas"
                        [ngClass]="{'fa-eye-slash':!showCurrrentPassword,'fa-eye':showCurrrentPassword}"></span></span>
                  </div>
                  <a href="{{forgotPwUrl}}" (click)="redirectToPasswordReset()" class="forgot-password">
                    {{'_My_Account_Forget_Password_Message_Text_' | translate }}
                  </a>
                  <div *ngIf="this.f2.currentpassword.invalid && (this.f2.currentpassword.dirty || this.f2.currentpassword.touched)"
                       class="cc-validation">
                    <div *ngIf="this.f2.currentpassword.errors?.required">
                      {{'_My_Account_Enter_Current_Password_Message_Text_' | translate }}
                    </div>
                  </div>
                </div>
                <div class="col">
                  <label for="newPassword">{{'_My_Account_New_Password_Label_Text_' | translate }}
                    <span tabindex="-1" class="required-field">*</span>
                  </label>
                  <div class="input-reveal">
                    <input id="newPassword" class="form-control" autocomplete="off" formControlName="newPassword"
                      (keypress)="omit_special_char($event)" [type]="showNewPassowrd ? 'text' : 'password'"
                      (paste)="passwordInputChange('newPassword')">
                    <span class="eye-icon" (click)="showNewPassowrd = !showNewPassowrd"><span class="fas"
                        [ngClass]="{'fa-eye-slash':!showNewPassowrd,'fa-eye':showNewPassowrd}"></span></span>
                  </div>
                  <div *ngIf="this.f2.newPassword.invalid && (this.f2.newPassword.dirty || this.f2.newPassword.touched)"
                    class="cc-validation">
                    <div *ngIf="this.f2.newPassword.errors?.required">
                      {{'_My_Account_Enter_New_Password_Message_Text_' | translate }}
                    </div>
                  </div>
                </div>
                <div class="col">
                  <!-- Supervisor -->
                  <label for="repeatPassword">{{'_My_Account_Re_Enter_New_Password_Label_Text_' | translate }}
                    <span tabindex="-1" class="required-field">*</span>
                  </label>
                  <div class="input-reveal">
                    <input id="repeatPassword" class="form-control" autocomplete="off" formControlName="repeatPassword"
                      (keypress)="omit_special_char($event)" [type]="showReEnterPassword ? 'text' : 'password'"
                      (paste)="passwordInputChange('repeatPassword')">
                    <span class="eye-icon" (click)="showReEnterPassword = !showReEnterPassword"><span class="fas"
                        [ngClass]="{'fa-eye-slash':!showReEnterPassword,'fa-eye':showReEnterPassword}"></span></span>
                  </div>
                  <div
                    *ngIf="this.f2.repeatPassword.invalid && (this.f2.repeatPassword.dirty || this.f2.repeatPassword.touched)"
                    class="cc-validation">
                    <div *ngIf="this.f2.repeatPassword.errors?.required">{{'_My_Account_Re_Enter_New_Password_Small_Label_Text_' | translate }}</div>
                    <div *ngIf="this.f2.repeatPassword.errors?.mustMatch">{{'_My_Account__Password_Not_Match_Message_Text_' | translate }}</div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="password-policy">
                  <p>
                    {{'_My_Account_Password_Requirement_Box_Message_Text_' | translate }}
                    <ul>
                      <li>{{'_My_Account_Password_Requirement_Box_Uppercase_Letter_Label_Text_' | translate }}</li>
                      <li>{{'_My_Account_Password_Requirement_Box_Lowercase_Letter_Label_Text_' | translate }}</li>
                      <li>{{'_My_Account_Password_Requirement_Box_Number_Label_Text_' | translate }}</li>
                      <li>{{'_My_Account_Password_Requirement_Box_Special_Character_Label_Text_' | translate }}</li>
                    </ul>
                    <br>
                    <p>
                      {{'_My_Account_Password_Cannot_Same_Last_7_Passwords_Message_Text_' | translate }}
                    </p>
                  <p>
                    {{'_My_Account_Password_Identical_Characters_Message_Text_' | translate }}
                  </p>
                  <p>
                    {{'_My_Account_Password_Consecutive_Repeating_Words_Message_Text_' | translate }}
                  </p>
                </div>
              </div>
              <div class="col-md-12 cc-validation"
                [style.visibility]="this.passwordErrors.length > 0 ? 'visible' : 'hidden'">
                <div *ngFor="let error of this.passwordErrors">{{error | translate}}</div>
              </div>
            </div>

            <!-- Button Panel -->
            <div class="cc-btn-panel">
              <button class="btn btn-secondary" type="button"  (click)="this.togglePanel('ngb-panel-1')">{{'_General_Button_Close_Text_' | translate }}</button>
              <button class="btn btn-primary"
                [disabled]="!this.passwordResetForm.dirty || !this.passwordResetForm.valid">{{'_General_Button_Save_Text_' | translate }}
              </button>
            </div>
          </form>
        </ng-template>
      </ngb-panel>
    </ngb-accordion>
  </div>
</div>
